// extracted by mini-css-extract-plugin
export default {"toggleButton":"LegendToggleButton_toggleButton__3IQ5+"};